module.exports = __webpack_public_path__ + "img/light_3.1d69c821.png";